export const Applicability = {
  All_Products: _TL_('All products'),
  Specific_Products: _TL_('Specific products '),
};
